module.exports = __webpack_public_path__ + "img/nimtu_medium.d07c6759.png";